var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "popup_wrap", staticStyle: { width: "750px" } },
    [
      _c(
        "button",
        {
          staticClass: "layer_close",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(" close ")]
      ),
      _c("div", { staticClass: "popup_cont" }, [
        _c("h1", { staticClass: "page_title" }, [
          _vm._v(_vm._s(_vm.$t("msg.NEWB020P030.003"))),
        ]),
        _c("div", { staticClass: "content_box mt10" }, [
          _c("span", { staticClass: "content_title_span" }, [
            _c("h2", [
              _c("strong", [_vm._v(_vm._s(_vm.$t("sc_preview.003")))]),
            ]),
          ]),
          _c("div", { staticClass: "cont text_left" }, [
            _c(
              "ul",
              {
                staticClass: "bul_list_sm",
                staticStyle: {
                  "list-style": "none",
                  "list-style-type": "none",
                },
              },
              [
                _c("li", [
                  _vm._v(" " + _vm._s(_vm.$t("sc_preview.004")) + " "),
                  _c("br"),
                  _vm._v(
                    ' "SC번호 - AMEND번호.pdf" 예) SC00001 - AMEND 000.pdf '
                  ),
                  _c("br"),
                ]),
              ]
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "content_box" },
          [
            _vm.customComponent
              ? _c(_vm.customComponent, {
                  ref: "dextupload",
                  tag: "component",
                  attrs: {
                    id: "dextupload1",
                    width: "100%",
                    height: "200px",
                    category: _vm.isCategory,
                    single: true,
                    "file-info": _vm.uploadFileList,
                    "category-info": _vm.msdsList,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("div", { staticClass: "mt10 text_center" }, [
          _c(
            "a",
            {
              staticClass: "button blue lg",
              attrs: { href: "#" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.insertFile()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("msg.NEWB020P030.004")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }